<template>
  <div class="table">
        <table>
            <thead>
                <tr>
                    <th colspan="2"></th>
                    <th colspan="2">Bronbestand</th>
                    <th colspan="2">Referentie</th>
                </tr>
                <tr>
                    <th>Bestekpostnummer</th>
                    <th>Omschrijving</th>
                    <th>Hoeveelheid</th>
                    <th>Eenheid</th>
                    <th>Hoeveelheid</th>
                    <th>Eenheid</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(specificationPost, key) in specificationPosts" :key="key">
                    <td v-html="specificationPost.specificationsPostNumber"></td>
                    <td v-html="specificationPost.description"></td>
                    <td v-html="specificationPost.value"></td>
                    <td v-html="specificationPost.unit"></td>
                    <td
                        :class="{
                            'cell-can-be-overwritten': specificationPost.canBeOverwritten,
                            'cell-must-be-overwritten': specificationPost.mustBeOverwritten,
                        }"
                        >
                        <q-input
                            v-if="editing === specificationPost.specificationsPostNumber"
                            v-model="specificationPost.referenceValue"
                            size="xsmall"
                            placeholder=""
                            style="width:60px"
                            @blur="(value) => { updateFormData(specificationPost, { overwriteValue: value }); editing = '' }"
                            autofocus
                        ></q-input>
                        <div 
                            v-else
                            :style="{
                                cursor: specificationPost.canBeOverwritten ? 'pointer' : 'default'
                            }"
                            @click="startEdit(specificationPost)">
                            <q-tooltip  position="top" :disabled="!specificationPost.mustBeOverwritten">
                                <template v-slot:tooltip>
                                    <span v-if="specificationPost.mustBeOverwritten">Deze waarde moet worden overschreven</span>
                                </template>
                                {{ specificationPost.referenceValue }}
                                <q-icon
                                    v-if="specificationPost.mustBeOverwritten"
                                    type="InfoCircle"
                                    :width="14"
                                    :height="14"
                                    style="margin-left: 4px"
                                ></q-icon
                            ></q-tooltip>
                        </div>
                    </td>
                    <td v-html="specificationPost.referenceUnit"></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'rsx-table',
    data() {
        return {
            editing: ''
        }
    },
    props: {
        specificationPosts: {
            type: Array,
            required: true,
            validator: (value) => {
                return value.every((specificationPost) => {
                    return specificationPost.hasOwnProperty('specificationsPostNumber') 
                    && specificationPost.hasOwnProperty('description')
                    && specificationPost.hasOwnProperty('unit') 
                    && specificationPost.hasOwnProperty('value') 
                    && specificationPost.hasOwnProperty('referenceValue')
                    && specificationPost.hasOwnProperty('referenceUnit')
                    && specificationPost.hasOwnProperty('canBeOverwritten')
                    && specificationPost.hasOwnProperty('mustBeOverwritten')
                })
            }
        },
    },
    methods: {
        updateFormData(specificationPost, data) { 
            let { overwriteValue } = data;

            if (overwriteValue) {
                if (isNaN(overwriteValue)) {
                    this.$store.commit('notify', {
                        type: 'danger',
                        message: 'Waarde moet een nummer zijn.'
                    })
                    return;
                }
                
                overwriteValue = parseFloat(overwriteValue);
                
                if (overwriteValue === specificationPost.referenceValue) {
                    return;
                }

                const updateData = {
                    specificationsPostNumber: specificationPost.specificationsPostNumber,
                    overwriteValue,
                }
    
                this.$emit('update', updateData);
            }

        },
        startEdit(specificationPost) {
            if (specificationPost.canBeOverwritten) {
                this.editing = specificationPost.specificationsPostNumber;
            }
        }
    },
}
</script>

<style scoped lang="scss">


th {
    font-weight: 400;
    font-size: 10px;
    padding: 4px 0;
}

tr {
    margin: 0;
}

th, td {
    border: 1px solid black;
    font-size: 12px;
    background-color: white;

    padding: 4px 6px;
}
table { 
    width: 100%;
    border-collapse: collapse;
}

td.cell-must-be-overwritten {
    background-color: #fffecc;
    color: #7c7000;
    font-weight: bold;
}

td.cell-can-be-overwritten:not(.cell-must-be-overwritten) {
    
}

</style>